import { createFetchReducer } from '@copilot/common/store/reducers/fetch';
import { LINKEDIN_PROFILE } from './constant';

export const linkedinProfileReducer = createFetchReducer(LINKEDIN_PROFILE);
